import React from 'react';
import ModuleLayout from '../../layouts/ModuleLayout';
import InventoryItemHistory from '../../components/Admin/Inventory/StockManagement/InventoryItemHistory';

/**
 * Inventory Item History Page
 * Route: /inventory/items/:id/history
 *
 * Thin wrapper page — all UI lives in the InventoryItemHistory component
 * (src/components/Admin/Inventory/StockManagement/InventoryItemHistory.jsx).
 */
export default function InventoryItemHistoryPage() {
  return (
    <ModuleLayout>
      <InventoryItemHistory />
    </ModuleLayout>
  );
}